import { useEffect } from 'react'

import {
  conversationSelector,
  paramsSelector,
  previousConversationSelector,
  uiStateSelector,
  useStore,
} from '@liveHelper/models/store'

import { usePIPControls } from '@core/pictureInPicture'

/**
 * Hook to control Picture-in-Picture mode for conversations.
 */
export const useConversationPIP = () => {
  const params = useStore(paramsSelector)
  const conversation = useStore(conversationSelector)
  const previousConversation = useStore(previousConversationSelector)
  const uiState = useStore(uiStateSelector)

  const { enter: enterPIP, exit: exitPIP } = usePIPControls({
    enabled: params.pip,
    params,
  })

  useEffect(() => {
    if (
      conversation ||
      // Conversation can be removed by agent and we should stay in PIP
      (previousConversation &&
        (uiState === 'chatting' || uiState === 'customer_survey'))
    ) {
      enterPIP()
    } else {
      exitPIP()
    }
  }, [conversation, enterPIP, exitPIP, previousConversation, uiState])
}
